const headerSearchInputs = document.querySelectorAll('[data-crown-header-search-input]');
const searchModal = document.getElementById('search-modal');

function getModalSearchInput() {
  return searchModal?.querySelector('.search-modal__content .search-input') || null;
}

function dispatchPredictiveSearch(input, value) {
  if (!value.trim()) return;

  try {
    input.dispatchEvent(
      new InputEvent('input', {
        bubbles: true,
        inputType: 'insertText',
        data: value.slice(-1),
      })
    );
  } catch {
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

function focusModalInput(input) {
  requestAnimationFrame(() => {
    input.focus({ preventScroll: true });
    const cursorPosition = input.value.length;
    input.setSelectionRange(cursorPosition, cursorPosition);
  });
}

function openPredictiveSearch(value = '') {
  const modalInput = getModalSearchInput();
  if (!searchModal || !modalInput) return false;

  if (typeof searchModal.showDialog === 'function') {
    searchModal.showDialog();
  } else {
    const dialog = searchModal.querySelector('dialog');
    if (dialog && !dialog.open) dialog.showModal();
  }

  if (value !== modalInput.value) {
    modalInput.value = value;
    dispatchPredictiveSearch(modalInput, value);
  } else if (value.trim()) {
    dispatchPredictiveSearch(modalInput, value);
  }

  focusModalInput(modalInput);
  return true;
}

headerSearchInputs.forEach((input) => {
  input.addEventListener('pointerdown', (event) => {
    if (!openPredictiveSearch(input.value)) return;

    event.preventDefault();
    input.value = '';
  });

  input.addEventListener('focus', () => {
    if (openPredictiveSearch(input.value)) {
      input.value = '';
    }
  });

  input.addEventListener('input', () => {
    if (openPredictiveSearch(input.value)) {
      input.value = '';
    }
  });
});

searchModal?.addEventListener('dialog:close', () => {
  headerSearchInputs.forEach((input) => {
    input.value = '';
  });
});
